// extracted by mini-css-extract-plugin
export var progressContainer = "_h2-0";